/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultiplePortfoliosDto
 */
export interface MultiplePortfoliosDto {
    /**
     * Number of users using this feature
     * @type {number}
     * @memberof MultiplePortfoliosDto
     */
    usersCount: number;
    /**
     * Percentage of total users
     * @type {number}
     * @memberof MultiplePortfoliosDto
     */
    percentage: number;
    /**
     * Average number of portfolios per user (for users with multiple)
     * @type {number}
     * @memberof MultiplePortfoliosDto
     */
    averageCount: number;
    /**
     * Maximum number of portfolios for a single user
     * @type {number}
     * @memberof MultiplePortfoliosDto
     */
    maxCount: number;
}

export function MultiplePortfoliosDtoFromJSON(json: any): MultiplePortfoliosDto {
    return MultiplePortfoliosDtoFromJSONTyped(json, false);
}

export function MultiplePortfoliosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiplePortfoliosDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'usersCount': json['usersCount'],
        'percentage': json['percentage'],
        'averageCount': json['averageCount'],
        'maxCount': json['maxCount'],
    };
}

export function MultiplePortfoliosDtoToJSON(value?: MultiplePortfoliosDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'usersCount': value.usersCount,
        'percentage': value.percentage,
        'averageCount': value.averageCount,
        'maxCount': value.maxCount,
    };
}

